import { render, staticRenderFns } from "./BlockType118.vue?vue&type=template&id=0db3a74c&scoped=true"
import script from "./BlockType118.vue?vue&type=script&lang=ts"
export * from "./BlockType118.vue?vue&type=script&lang=ts"
import style0 from "./BlockType118.vue?vue&type=style&index=0&id=0db3a74c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db3a74c",
  null
  
)

export default component.exports